// Add your custom JS here.
/*!
 * jQuery Cookie Plugin v1.4.0
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as anonymous module.
        define(['jquery'], factory);
    } else {
        // Browser globals.
        factory(jQuery);
    }
}(function ($) {

    var pluses = /\+/g;

    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }

    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }

    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }

    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            // This is a quoted cookie as according to RFC2068, unescape...
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }

        try {
            // Replace server-side written pluses with spaces.
            // If we can't decode the cookie, ignore it, it's unusable.
            // If we can't parse the cookie, ignore it, it's unusable.
            s = decodeURIComponent(s.replace(pluses, ' '));
            return config.json ? JSON.parse(s) : s;
        } catch(e) {}
    }

    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }

    var config = $.cookie = function (key, value, options) {

        // Write

        if (value !== undefined && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setTime(+t + days * 864e+5);
            }

            return (document.cookie = [
                encode(key), '=', stringifyCookieValue(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path    ? '; path=' + options.path : '',
                options.domain  ? '; domain=' + options.domain : '',
                options.secure  ? '; secure' : ''
            ].join(''));
        }

        // Read

        var result = key ? undefined : {};

        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all. Also prevents odd result when
        // calling $.cookie().
        var cookies = document.cookie ? document.cookie.split('; ') : [];

        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split('=');
            var name = decode(parts.shift());
            var cookie = parts.join('=');

            if (key && key === name) {
                // If second argument (value) is a function it's a converter...
                result = read(cookie, value);
                break;
            }

            // Prevent storing a cookie that we couldn't decode.
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }

        return result;
    };

    config.defaults = {};

    $.removeCookie = function (key, options) {
        if ($.cookie(key) === undefined) {
            return false;
        }

        // Must not alter options, thus extending a fresh object...
        $.cookie(key, '', $.extend({}, options, { expires: -1 }));
        return !$.cookie(key);
    };

}));
// -----------
// Debugger that shows view port size. Helps when making responsive designs.
// -----------
function showViewPortSize(display) {
	if(display) {
		var height = window.innerHeight;
		var width = window.innerWidth;
		jQuery('body').prepend('<div id="viewportsize" style="z-index:9999;position:fixed;bottom:0px;left:0px;color:#fff;background:#000;padding:10px">Height: '+height+'<br>Width: '+width+'</div>');
		jQuery(window).resize(function() {
			height = window.innerHeight;
			width = window.innerWidth;
			jQuery('#viewportsize').html('Height: '+height+'<br>Width: '+width);
		});
	}
}
function enableDirCardHover() {
	if(jQuery(window).width() > 1200) {
		jQuery(".nav_card_heading").parent('.nav_card').hover(
			function() {
				jQuery(this).children('.collapse').collapse('show');
			}, function() {
				jQuery(this).children('.collapse').collapse('hide');
			}
		);
	}
}
function checkMobileNav() {
	if( jQuery( window ).width() < 1200) {
		var offcanvas = jQuery('#navbarNavOffcanvas').height();
		var offcanvas_wrap = jQuery('#offcanvasWrap').height(); 
		var win_height = jQuery(window).height();
		var win_adjusted = win_height - 30;

		if (offcanvas_wrap > win_adjusted ) {
			if (jQuery('#navbarNavOffcanvas').hasClass('mobile_menu_scrollable')) {
			  //do nothing, were good
			} else {
				//add the class
				jQuery('#navbarNavOffcanvas').addClass('mobile_menu_scrollable');
			}
		} else {
			jQuery('#navbarNavOffcanvas').removeClass('mobile_menu_scrollable');
		}
	}
}



var $mobileFilter = jQuery('#mobileFilter');


jQuery( document ).ready(function($) {

	//Tooltips
	jQuery("[data-bs-toggle='tooltip']").tooltip();

	//Cookies
	$('.alert .btn-close').click(function() { 
		$.cookie('alertCookie', 'dismissed', { expires: 30 });
	});

	//Add class when element is stuck

	const el = document.querySelector(".sticky-top")
	const observer = new IntersectionObserver( 
	  ([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1),
	  { threshold: [1] }
	);
	observer.observe(el);

	//figure out something else for this
	$( '.no-link a' ).each(function(index) {
	    $(this).on('click', function(e){
	    	event.stopPropagation();
	    });
	});

	//Slick Sliders
	$('.case-study-slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 5000,
		adaptiveHeight: false,
	});
	$('.client-logo-slider').slick({
		dots: false,
		arrows: false,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		adaptiveHeight: true,
	});
	//Tile Content
	$('.multi_shot_slider').slick({
		dots: true,
		arrows: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 5000,
		adaptiveHeight: true,
	});
	$('.multi_slider').slick({
		dots: true,
		arrows: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 5000,
		adaptiveHeight: true,
	});
	$('.text_shot_slider').slick({
		dots: true,
		arrows: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 5000,
		adaptiveHeight: true,
	});

	//Tile Content Sidebar Navigation
	$( '.nav_item_link' ).each(function(index) {
	    $(this).on('click', function(e){
	    	e.preventDefault();
	        // panel to show
	        var parentContext = $(this).closest('.navbox_frame');
	        var navbox = $(this).data('navbox');
	        $('.nav_item_link',parentContext).removeClass('active');
	        $(this).addClass('active');
			$('.content_item',parentContext).hide();
			$('#'+ navbox +'',parentContext).show();
			$('.multi_shot_slider',parentContext).slick('refresh');
			$('.text_shot_slider',parentContext).slick('refresh');
			$('.multi_slider').slick('refresh');
	    });
	});

	// Directory
	var dir_nav_cards = $('.two-column .directory_nav_panel.desktop .nav_card');
	var split = Math.ceil(dir_nav_cards.length/2);
	dir_nav_cards.slice(0, split).wrapAll('<div class="colwrap"></div>');
	dir_nav_cards.slice(split, dir_nav_cards.length ).wrapAll('<div class="colwrap"></div>');




	$('.dropdown-toggle').on('click',function(e){
		if( $( window ).width() < 1200) {
			//$('#navbarNavOffcanvas').height() is variable depending on what menu item is open
			var offcanvas = $('#navbarNavOffcanvas').height(); 
			var offcanvas_wrap = $('#offcanvasWrap').height(); 
			var win_height = $(window).height();
			var win_adjusted = win_height - 30;

			if (offcanvas_wrap > win_adjusted ) {
				if ($('#navbarNavOffcanvas').hasClass('mobile_menu_scrollable')) {
				  //do nothing, were good
				} else {
					$('#navbarNavOffcanvas').addClass('mobile_menu_scrollable');
				}
			} else {
				$('#navbarNavOffcanvas').removeClass('mobile_menu_scrollable');
			}
		}	
	});



	//Resource Filter
	$( '.btn.filter' ).each(function(index) {
	    $(this).on('click', function(e){
	    	e.preventDefault();
	        // panel to show
	        var parentContext = $(this).closest('.button_group');
	        $('.btn.filter',parentContext).removeClass('active');
	        $(this).addClass('active');
	        getWPPostsNoOffset();
	    });
	});

	$("#solutionSelect, #industrySelect").on("change",function(){
		getWPPostsNoOffset()
	});



	function getWPPosts(solution,industry,tags,offset) {

		jQuery.ajax({

			url : '/wp-json/secureauth_rest/v1/get-posts',
			type : 'GET',
			data : {
				'solution' : solution,
				'industry' : industry,
				'tags' : tags,
				'offset' : offset
			},
			dataType:'json',
			/*beforeSend: function ( xhr ) {
			    xhr.setRequestHeader( 'X-WP-Nonce', _nonce );
			},*/
			success : function(data) {
			    console.log("REST DATA");
			    console.log(data);
			    data = data.replace(/\n/g," ");
			    data = data.replace(/\t/g," ");
			    data = data.replace(/\"/g,'"');
			    data = data.replace(/\//g,"/");
			    console.log("NEW STRING");
			    console.log(data);

			    if (offset == "0") {
			    	$(".grid_frame").html(data);
			    } else {
			    	$(".grid_frame").html($(".grid_frame").html() + data);
			    }

			    if ( $(".grid_frame .mini_card").length == (offset+15)) {
			    	$(".view-more").data('offset',offset+15);
			    } else {
			    	$(".view-more").hide();
			    }


			},
			error : function(request,error)
			{
			    console.log("Tile Fetch Error - Request: "+JSON.stringify(request)+" :: "+JSON.stringify(error));
			}
		});
	}
	function getWPPostsOptionSolution() {
		var solution = $("#solutionSelect").val();
		if (solution == "all") {
			return null;
		} else {
			return solution;
		}
	}
	function getWPPostsOptionIndustry() {		
		var industry = $("#industrySelect").val();
		if (industry == "all") {
			return null;
		} else {
			return industry;
		}
	}

	function getWPPostsOptionTag() {	
		var tag = $("#filterSelect a.active").data("filter-name");
		if (tag == "all") {
			return null;
		} else {
			return tag;
		}
	}
	function getWPPostsNoOffset() {
		$(".view-more").show();
		$(".view-more").data('offset',15);
		getWPPosts(getWPPostsOptionSolution(),getWPPostsOptionIndustry(),getWPPostsOptionTag(),0);

	}

	$(".view-more").on("click",function(e){
		e.preventDefault();
		getWPPosts(getWPPostsOptionSolution(),getWPPostsOptionIndustry(),getWPPostsOptionTag(),$(this).data('offset'));
	});








	//On Load Events
	$(window).load(function() {
	 	//do stuff
	});


	$(window).resize(function(){
		//check if mobile nav is open and needs to have overflow scroll, not currently working
	  	if( $( window ).width() < 1200) {
			var offcanvas = $('#navbarNavOffcanvas').height();
			var offcanvas_wrap = $('#offcanvasWrap').height(); 
			var win_height = $(window).height();
			var win_adjusted = win_height - 30;

			if (offcanvas_wrap > win_adjusted ) {
				if ($('#navbarNavOffcanvas').hasClass('mobile_menu_scrollable')) {
				  //do nothing, were good
				} else {
					//add the class
					$('#navbarNavOffcanvas').addClass('mobile_menu_scrollable');
				}
			} else {
				$('#navbarNavOffcanvas').removeClass('mobile_menu_scrollable');
			}
		}
		//enableDirCardHover();
		checkMobileNav();
	});


	

	//Resources desktop filter
	$('.desktop .cat-list_item').on('click', function() {
	  $('.desktop .cat-list_item').removeClass('active');
	  $(this).addClass('active');

	  $.ajax({
	    type: 'POST',
	    url: '/wp-admin/admin-ajax.php',
	    dataType: 'html',
	    data: {
	      action: 'filter_cards',
	      category: $(this).data('slug'),
	    },
	    success: function(res) {
	      $('#card-row').html(res);
	    }
	  })
	});

	//Resources mobile filter
	$('.cat-list .form-select').on('change', function() {

	  $.ajax({
	    type: 'POST',
	    url: '/wp-admin/admin-ajax.php',
	    dataType: 'html',
	    data: {
	      action: 'filter_cards',
	      category: $(this).val(),
	    },
	    success: function(res) {
	      $('#card-row').html(res);
	    }
	  })
	});




	$(function() {  
		//var $mobileFilter = $('#mobileFilter');
		if($mobileFilter.length == 0){
			//do nothing
			console.log('$mobileFilter does not exist');
		}else{
			// #mobileFilter exists
			console.log('$mobileFilter exists');
			$(window).scroll(function () { 
				if ($mobileFilter.offset().top - $(this).scrollTop() > 64.5) {
					$mobileFilter.removeClass('shadow');
				} else {
					$mobileFilter.addClass('shadow');
				}
			});

		}
	});


	var $navbox_videoSrc;  
	$('.video_trigger, .cta_video_trigger').click(function(e) {
		e.preventDefault();
		console.log('video_trigger click');
	    $navbox_videoSrc = $(this).data( "src" );
	    console.log($navbox_videoSrc);
	});
	// when the modal is opened autoplay it  
	$('#navbox_videoModal').on('shown.bs.modal', function (e) {
	    // set the video src to autoplay and not to show related video.
		$("#navbox-video").attr('src',$navbox_videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");

	});
	// stop playing the youtube video when I close the modal
	$('#navbox_videoModal').on('hide.bs.modal', function (e) {
	    // a poor man's stop video
	    $("#navbox-video").attr('src',$navbox_videoSrc); 
	});
	// Gets the video src from the data-src on each button

	var $videoSrc;  
	$('.video-btn').click(function() {
		console.log('btn click');
	    $videoSrc = $(this).data( "src" );
	    console.log($videoSrc);
	});
	//console.log($videoSrc);
	$('.app-video').click(function() {
		console.log('btn click');
	    $videoSrc = $(this).data( "src" );
	    console.log($videoSrc);
	});
	  
	  
	// when the modal is opened autoplay it  
	$('#saModal').on('shown.bs.modal', function (e) {  
		// set the video src to autoplay and not to show related video.
		$("#video").attr('src',$videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
	});
	  
	var $blank_url;
	$blank_url = '';


	$('#navbox_videoModal').on('hide.bs.modal', function (e) {
		$blank_url = '';
	    // a poor man's stop video
	    $("#navbox-video").attr('src',$blank_url); 
	});


	$('#saModal').on('hide.bs.modal', function (e) {
		$blank_url = '';
	    // a poor man's stop video
	    $("#video").attr('src',$blank_url); 
	}); 



	//Gravity Forms
	$('.wrapper .form-control').focus(function () {
		console.log('focus');
	    $(this).prev('.form-label').removeClass('hidden');

	}).blur(function () {
		console.log('lost focus');
	    $(this).prev('.form-label').addClass('hidden');
	});

	jQuery('.gform_body input').each(function () { 
		jQuery(this).on('focus', function () {
			jQuery(this).parent().parent('.gfield').addClass('active');
		}); 
		jQuery(this).on('blur', function () { 
			if (jQuery(this).val().length == 0) { 
				jQuery(this).parent().parent('.gfield').removeClass('active'); 
			} 
		}); 
		//if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active'); 
		if (jQuery(this).val() != '') jQuery(this).parent().parent('.gfield').addClass('active'); 
	});

	jQuery('.gform_body .ginput_complex span input').each(function () { 
		jQuery(this).on('focus', function () {
			//jQuery(this).parent().parent('.ginput_complex span').addClass('active');  
			jQuery(this).parent().addClass('active');  
		}); 
		jQuery(this).on('blur', function () { 
			if (jQuery(this).val().length == 0) { 
				jQuery(this).parent().removeClass('active'); 
			} 
		}); 
		if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active'); 
	}); 

	jQuery('.gform_body textarea').each(function () { 
		jQuery(this).on('focus', function () { 
			jQuery(this).parent().parent('.gfield').addClass('active'); 
		}); 
		jQuery(this).on('blur', function () { 
			if ($(this).val().length == 0) { 
				jQuery(this).parent().parent('.gfield').removeClass('active'); 
			} 
		}); 
		if (jQuery(this).val() != '') jQuery(this).parent('.css').addClass('active'); 
	});




	$('.collapse').on('shown.bs.collapse', function () {
		$(this).addClass('open')
	});

	$('.collapse').on('hidden.bs.collapse', function () {
		$(this).removeClass('open')
	});


	


// showViewPortSize(true); //Uncomment to debug


//End (document).ready

});